import React, { createRef } from "react"
import { DebounceInput } from "react-debounce-input"

interface Props {
  performLookup: (q: string) => Promise<Result[]>
  renderSearchResultRow: (result: Result, resetSearchStateFn: () => any) => any
  placeholder?: string
  debounceInput?: boolean
}
interface SearchBarState {
  searching: boolean
  query: string
  results: Result[]
}

type Result = any

class SearchBar extends React.Component<Props, SearchBarState> {
  inputRef: any

  constructor(props: Props) {
    super(props)
    this.state = SearchBar.baseState()
    this.inputRef = createRef()
  }

  static baseState() {
    return { searching: false, query: "", results: [] }
  }

  changeQuery = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ searching: true, query: e.target.value })
    this.performLookup(e.target.value)
  }

  resetSearchState = () => {
    this.setState(SearchBar.baseState())
    this.inputRef.current?.focus?.()
  }

  noResultsSection() {
    const { query, results, searching } = this.state
    let message = null
    if (searching) {
      message = "Searching..."
    } else if (query.length > 2 && results.length === 0) {
      message = "No Results"
    }

    if (message) {
      return <div className="px-2 my-2 leading-loose text-gray-600">{message}</div>
    }
  }

  performLookup(query: string) {
    query = query.substring(0, 100)
    if (query.length > 2) {
      this.props.performLookup(query).then((results: Result[]) => {
        this.setState({ searching: false, results: results })
      })
    } else {
      this.setState({ searching: false, results: [] })
    }
  }

  onBlur = () => {
    // NOTE: The timeout has been set to allow user to click on search results.
    //       Otherwise search results will be reset before click event and disappear with no effect
    setTimeout(this.resetSearchState, 100)
  }

  render() {
    const shouldDebounce = this.props.debounceInput ?? true
    return (
      <div className="search-bar__input-holder">
        {shouldDebounce ? (
          <DebounceInput
            type="search"
            ref={this.inputRef}
            className="border-none padding-h-s search-bar__input"
            value={this.state.query}
            onChange={this.changeQuery}
            placeholder={this.props.placeholder || "Search..."}
            data-role="passenger-search-input"
            debounceTimeout={250}
          />
        ) : (
          <input
            type="search"
            ref={this.inputRef}
            className="border-none padding-h-s search-bar__input"
            value={this.state.query}
            onChange={this.changeQuery}
            placeholder={this.props.placeholder || "Search..."}
            data-role="passenger-search-input"
          />
        )}
        <div className="search-results">
          <div>{this.noResultsSection()}</div>
          {this.state.results.map((r: Result) => (
            <div key={r.id}>{this.props.renderSearchResultRow(r, this.resetSearchState)}</div>
          ))}
        </div>
      </div>
    )
  }
}

export default SearchBar
